import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Observable } from 'rxjs/Observable';
import { DESCRICAO_CARD } from '../../app.constants';
import { ItemMenu } from '../shared/dominios/item-menu';
import { CardModel } from '../shared/models/card.model';
import { PaginaCardsModel } from '../shared/models/pagina-cards.model';
import { FuncoesCardMenu } from '../shared/util/funcaoes-card-menu/funcoes-card-menu';
import { StorafeUtil } from '../shared/util/storasge.util';
import { CardsMenuService } from './service/cards-menu.service';


@Component({
  selector: 'app-card-menu',
  templateUrl: './card-menu.component.html',
  styleUrls: ['./card-menu.component.css']
})
export class CardMenuComponent implements OnInit {


  @BlockUI() blockUi: NgBlockUI;

  paginaCards: Array<PaginaCardsModel> = new Array<PaginaCardsModel>();

  disabled = false;

  itemMenu$: Observable<ItemMenu[]>;

  constructor(
    private funcoesCardMenu: FuncoesCardMenu,
    private cardsMenuService: CardsMenuService,
    private router: Router,
    private store: Store<ItemMenu>,
  ) {
    this.itemMenu$ = store.pipe(select('itemMenuLista'));
  }

  ngOnInit() {

    this.getCardsMenu()
  }

  async getCardsMenu() {
    // this.blockUi.start('Carregando...');

    try {
      this.paginaCards = await this.funcoesCardMenu.carregarItensCardsPaginaInial();

      // this.itemMenu$.subscribe((arg) => this.agruparItensMenu(arg));
    } catch (error) {
      console.error(error);
    } finally {
      // this.blockUi.stop();
    }
  }



  direcionar(dadosCards: CardModel): void {
    
    if (dadosCards.sigla.toLowerCase() === 'aec'.toLowerCase()
    || dadosCards.sigla.toLowerCase() === 'mv2020'.toLowerCase()) {
      
      console.log(dadosCards.caminho);
      window
        .open(dadosCards.caminho)
      return;
    };

    this.router.navigate([dadosCards.caminho]);
    StorafeUtil.gravaSessionStorage(DESCRICAO_CARD, dadosCards.sigla)
  }


  // this.funcoesCardMenu.direcionar(dadosCards);
  // this.cardsMenuService.getIpCliente().subscribe(arg => console.log(arg));
  // this.cardsMenuService.getIpCliente1().subscribe(arg => console.log(arg));
  // this.cardsMenuService.getIpCliente2().subscribe(arg => console.log(arg));
  // this.cardsMenuService.getIpCliente3().subscribe(arg => console.log(arg));





}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/card-menu/card-menu.component.ts